import { List as MuiList } from '@mui/material';
import { styled } from '@mui/material/styles';

export const List = styled(MuiList)({
  padding: '8px 0 0',
});
